function getRegisterFriendlyName(registerName) {
    switch (registerName) {
        case "TH_prelevement":
            return "Mono-horaire - Prélèvement"
        case "HI_prelevement":
            return "Heures pleines - Prélèvement"
        case "LO_prelevement":
            return "Heures creuses - Prélèvement"
        case "PK_prelevement":
            return "Heures pics - Prélèvement"
        case "MD_prelevement":
            return "Heures médiums - Prélèvement"
        case "EC_prelevement":
            return "Heures écos - Prélèvement"
        case "TH_injection":
            return "Mono-horaire - Injection"
        case "HI_injection":
            return "Heures pleines - Injection"
        case "LO_injection":
            return "Heures creuses - Injection"
        case "PK_injection":
            return "Heures pics - Injection"
        case "MD_injection":
            return "Heures médiums - Injection"
        case "EC_injection":
            return "Heures écos - Injection"
        case "EX_prelevement":
            return "Exclusif nuit - Prélèvement"
        case "EX_injection":
            return "Exclusif nuit - Injection"
        default:
            return registerName
    }
}

exports.getRegisterFriendlyName = getRegisterFriendlyName